import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderModule } from 'src/components/header/header.module';
import { SidenavModule } from 'src/components/sidenav/sidenav.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UsertableModule } from 'src/components/usertable/usertable.module';
import { UnknownRequestModule } from 'src/components/unknown-request/unknown-request.module';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthenticationIntercepter } from './service/system/authentication.intercepter';
import { AuthenticationGuard, MsAdalAngular6Module } from 'microsoft-adal-angular6';
import { environment } from 'src/environments/environment';
import { DatePipe } from '@angular/common';
import { EnvServiceProvider } from './service/system/env.service.provider';
import { AppConfigService } from './service/system/app-config.service';

var customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 5000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

export function appInit(appConfigService: AppConfigService) {
  return () => appConfigService.load();
}

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    NotifierModule.withConfig(customNotifierOptions),
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    SidenavModule,
    MatProgressSpinnerModule,
    HeaderModule,
    UsertableModule,
    UnknownRequestModule,
    AppRoutingModule,
    BrowserAnimationsModule,
  
    MsAdalAngular6Module.forRoot({
      tenant: window['__env']['azuread_tenant'],
      clientId: window['__env']['azuread_clientId'],
      redirectUri: window.location.origin,
      endpoints: environment.azuread.endpoints,
      navigateToLoginRequestUrl: false,
      cacheLocation: 'localStorage'
    })
  ],
  providers: [
    AppConfigService,
    {
      provide: APP_INITIALIZER,
      useFactory: appInit,
      multi: true,
      deps: [AppConfigService]
    },
    AuthenticationGuard,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationIntercepter,
      multi: true
    },
    EnvServiceProvider
  ],
  bootstrap: [AppComponent]
})

export class AppModule { }

var customNotifierOptions: NotifierOptions = {
  position: {
    horizontal: {
      position: 'right',
      distance: 12
    },
    vertical: {
      position: 'top',
      distance: 12,
      gap: 10
    }
  },
  theme: 'material',
  behaviour: {
    autoHide: 3000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  }
};
